import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import {
  Loader, Container, Grid, Input, Card,
} from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import styled from 'styled-components';
import useTheme from 'theme/useTheme';
import toast from 'react-hot-toast';
import util from 'utils/utils';
import useThrottle from 'utils/useThrottle';
import api from 'api';
import {
  Banner, RoundButton, EmptyBox,
} from 'components/lib/UI';

import GroupCard, { GroupCardListView } from 'components/lib/Cards/GroupCard';

const StyledInput = styled(Input)`
  /* width: ${({ theme }) => (theme.sizes.isMobile ? '100%' : '66%')}; */
`;

const Groups = ({
  user, t,
}) => {
  const [yourGroups, setYourGroups] = useState([]);
  const [discoverGroups, setDiscoverGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchInput, setSearchInput] = useState('');
  const theme = useTheme();

  const getGroups = useThrottle(() => {
    api.journey.record('groups', null, 'viewGroupsPage');
    setLoading(true);
    const searchFilter = (g) => {
      const groupName = (g.name || '').toLowerCase();
      return !searchInput || groupName.includes(searchInput.toLowerCase());
    };
    api.groups.discover((groups) => {
      setYourGroups(groups.filter((g) => searchFilter(g) && g.isInGroup));
      setDiscoverGroups(groups.filter((g) => searchFilter(g) && !g.isInGroup));
      setLoading(false);
    }, (err) => {
      toast.error(err.message);
      setLoading(false);
    });
  }, 400, [searchInput]);

  useEffect(() => getGroups(), [getGroups]);

  return (
    <div>
      <Helmet title={'Your groups'} />
      <Banner marginless>
        <Container>
          <Grid stackable>
            <Grid.Column computer={9}>
              <h1 style={{ color: '#3b3b3b', margin: '0px' }}>Your groups</h1>
              <p >{t('groups.discover.info')}</p>
            </Grid.Column>
            <Grid.Column computer={7} textAlign='right' verticalAlign='bottom'>
              {util.isInRole(user, 'org.createGroups', user.organisation._id) && (
                <RoundButton size={theme?.sizes?.isMobile ? 'tiny' : 'medium'} floated='right' as={Link} to='/groups/new' inverted icon='plus' content={t('groups.discover.create')} />
              )}
            </Grid.Column>
          </Grid>
        </Container>
      </Banner>
      <Container style={{ marginTop: '1rem' }}>
        {loading && <Loader active />}
        {!loading && !yourGroups.length && !discoverGroups.length
          ? (
            <EmptyBox>
              <h2>
                {searchInput.length ? t('groups.groups.noneTerm') : t('groups.groups.none')}
              </h2>
            </EmptyBox>
          ) : null
        }
        <StyledInput
          theme={theme}
          value={searchInput}
          placeholder='Search groups...'
          onChange={(e, { value }) => setSearchInput(value)}
        />
        <Grid style={{ marginTop: '1rem' }} columns={((yourGroups.length && discoverGroups.length) && theme.sizes.isComputer) ? 2 : 1} divided={!!(yourGroups.length || discoverGroups.length)}>
          <Grid.Row>
            {yourGroups.length
              ? (
                <Grid.Column size={8}>
                  <h2 style={{ marginBottom: 20 }}>{t('groups.groups.member')}</h2>
                  {yourGroups.map((group) => <GroupCardListView key={group._id} group={group} />)}
                </Grid.Column>
              ) : null
            }
            {discoverGroups.length
              ? (
                <Grid.Column size={8} style={!theme.sizes.isComputer ? { marginTop: 20 } : {}}>
                  <h2 style={{ marginBottom: 20 }}>{t('groups.discover.title')}</h2>
                  <Card.Group itemsPerRow={theme.sizes.isMobile ? 1 : 2}>
                    {discoverGroups.map((group) => <GroupCard key={group._id} group={group} />)}
                  </Card.Group>
                </Grid.Column>
              ) : null
            }
          </Grid.Row>
        </Grid>
      </Container>
    </div >
  );
};

export default withTranslation()(
  connect((state) => ({ user: state.user }), null)(Groups),
);
